import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js"
import { Line } from "react-chartjs-2"

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler)

const WeatherChart = ({ weatherData, yearRange }) => {
  if (!weatherData || weatherData.length === 0) {
    return (
      <div className="text-center py-4 text-muted">
        <p>No weather data available</p>
      </div>
    )
  }

  // Sample data for the first 30 days or available data
  const chartData = weatherData.slice(0, 30)

  const data = {
    labels: chartData.map((_, index) => `Day ${index + 1}`),
    datasets: [
      {
        label: "Min Temperature (°C)",
        data: chartData.map((day) => day.minTemp),
        borderColor: "rgb(54, 162, 235)",
        backgroundColor: "rgba(54, 162, 235, 0.1)",
        fill: false,
        tension: 0.4,
      },
      {
        label: "Max Temperature (°C)",
        data: chartData.map((day) => day.maxTemp),
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.1)",
        fill: false,
        tension: 0.4,
      },
      {
        label: "Avg Temperature (°C)",
        data: chartData.map((day) => day.avgTemp),
        borderColor: "rgb(75, 192, 192)",
        backgroundColor: "rgba(75, 192, 192, 0.1)",
        fill: true,
        tension: 0.4,
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: `Temperature Trends (${yearRange} Year${yearRange > 1 ? "s" : ""} Average)`,
      },
      tooltip: {
        mode: "index",
        intersect: false,
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.parsed.y.toFixed(1)}°C`,
        },
      },
    },
    scales: {
      x: {
        display: true,
        title: {
          display: true,
          text: "Days",
        },
      },
      y: {
        display: true,
        title: {
          display: true,
          text: "Temperature (°C)",
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
  }

  return (
    <div style={{ height: "300px" }}>
      <Line data={data} options={options} />
    </div>
  )
}

export default WeatherChart
